import { trackEvent } from '@zola-helpers/client/dist/es/tracking/trackingHelper';

export function trackRecommendation(action, recommendationData) {
  trackEvent(`CTA Recommendation ${action}`, recommendationData);
}

export function trackProductClicked(productData) {
  trackEvent('Product Clicked', productData);
}

/**
 * Takes an item from the cart API and reformats it to fit
 * the expectations of the CartViewed Segment Event
 * @param {Object} i an item as returned from the cart API
 * @param {Integer} idx the index of the item
 */
const normalizeItem = (i, idx) => ({
  product_id: i.productId,
  sku: i.skuId,
  name: i.productName,
  brand: i.brandName,
  variant: i.productLookId,
  price: i.subtotal,
  quantity: i.contribution.quantity,
  position: idx,
  url: i.itemLink,
  image_url: i.imageLink,
});

export function trackCartViewed(registryId, cartId, items) {
  const itemsPayload = [];

  // loop over all items and add them to the event payload
  items.forEach((i, idx) => {
    // for normal products, push directly onto array
    if (i.contribution) {
      itemsPayload.push(normalizeItem(i, idx));
    }
    // for parent products with children, push children onto array with same index as parent
    if (i.childItems) {
      i.childItems.forEach((c) => {
        itemsPayload.push(normalizeItem(c, idx));
      });
    }
  });
  const payload = {
    registry_id: registryId,
    cart_id: cartId,
    products: itemsPayload,
  };
  trackEvent('Cart Viewed', payload);
}

export function trackNavigationClicked(eventData) {
  trackEvent('Navigation Clicked', eventData);
}

export function trackSearchSuggestionClicked(eventData) {
  trackEvent('Search Suggestion Clicked', eventData);
}

export function trackProductsSearched(eventData) {
  trackEvent('Products Searched', eventData);
}

export function trackSearchTabClicked(eventData) {
  trackEvent('Search Tab Clicked', eventData);
}

export function trackModalViewed(eventData) {
  trackEvent('Modal Viewed', eventData);
}

export function trackModalClicked(eventData) {
  trackEvent('Modal Clicked', eventData);
}
